<template>
  <div>
    <Tabs type="card" :value="softWareTabValue" @on-click="cutoverTab">
      <TabPane label="授权软件申请" name="workflowTab">
        <software-workflow/>
      </TabPane>
      <TabPane label="软件价格" name="priceTab">
        <software-price/>
      </TabPane>
      <TabPane label="授权软件" name="authorizeTab">
        <software-authorize/>
      </TabPane>
      <TabPane label="授权软件分配" name="distributeTab">
        <software-distribute/>
      </TabPane>
      <TabPane label="部门软件使用统计" name="reportTab">
        <software-report/>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>

import softwareWorkflow from './software-workflow.vue'
import softwarePrice from './software-price.vue'
import softwareAuthorize from './software-authorize.vue'
import softwareDistribute from './software-distribute.vue'
import softwareReport from './software-report.vue'

export default {
  name: 'softwareIndex',

  components: { softwareWorkflow, softwarePrice, softwareAuthorize, softwareDistribute, softwareReport },

  data () {
    return {
      softWareTabValue: 'workflowTab'
    }
  },

  mounted: function () {

  },

  methods: {

    cutoverTab (name) {
      this.tabValue = name
    }

  }

}
</script>
